<template>
  <div class="admin-tab">
    <wb-datatable
      v-bind="tableProps"
      @addEmit="openDialog"
      @editEmit="openDialog"
      @deleteEmit="openConfirmDialog"
      :searchKey="'userEmail'"
    ></wb-datatable>
    <md-dialog ref="dialog">
      <md-dialog-title>{{isNew ? 'Create role' : 'Update role'}}</md-dialog-title>
      <md-dialog-content>
        <form v-if="role">
          <md-input-container>
            <multiselect id="userEmail"
                v-model="selectedUser"
                :options="usersCopy"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                placeholder="User Email"
                label="email"
                @input="changeUser(role, selectedUser)"
            >
            </multiselect>
          </md-input-container>
          <md-input-container>
            <multiselect id="appName"
               v-model="selectedApp"
               :options="appsCopy"
               :multiple="false"
               :close-on-select="true"
               :clear-on-select="false"
               placeholder="App Name"
               label="displayName"
               @input="changeApp(role, selectedApp)"
            >
            </multiselect>
          </md-input-container>
          <md-input-container>
            <label>Role</label>
            <md-input v-model="role.role"></md-input>
          </md-input-container>
        </form>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeDialog(false)">Cancel</md-button>
        <md-button class="md-primary" :disabled="!role || !role.role || !selectedUser || !selectedApp" @click="closeDialog(true)">{{isNew ? 'Create' : 'Update'}}</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog ref="confirmDialog">
      <md-dialog-title>Are you sure you would like to remove this role?</md-dialog-title>

      <md-dialog-content>
        Role will permanently be removed from the database
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeConfirmDialog(false)">Cancel</md-button>
        <md-button class="md-primary" @click="closeConfirmDialog(true)">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import wbDataTable from 'WBDataTable';
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import _ from 'underscore';

export default {
  name: 'AdminRoles',
  components: {
    'wb-datatable': wbDataTable,
    Multiselect,
  },
  data() {
    return {
      role: null,
      selectedUser: null,
      selectedApp : null,
      isNew: false,
      appsCopy: null,
      usersCopy: null,
      tableProps: {
        dataext: [],
        columns:[
          {name: 'id', displayName: 'ID', visible: false, type:'number', isEditable:false},
          {name: 'appId', displayName: 'App ID', visible: true, type:'string', isEditable:false},
          {name: 'displayName', displayName: 'App Name', visible: true, type:'string', isEditable:false},
          {name: 'userEmail', displayName: 'User email', visible: true, type:'string', isEditable:false},
          {name: 'role', displayName: 'Role', visible: true, type:'string', isEditable:false},
        ],
        hasControls: true,
        allowCreation: true,
        disableSearch: false,
        pagination: {
          size: 50
        }
      },
      roles: null
    }
  },
  watch: {},
  validations: {},
  computed: {
    ...mapGetters([
      'apps',
      'users'
    ])
  },
  methods: {
    changeUser(role, user) {
      role.user = Object.assign({}, user);
      role.userId = user.id;
    },
    changeApp(role, app) {
      role.app = Object.assign({}, app);
      role.appId = app.id;
    },
    parseRoles(roles) {
      this.tableProps.dataext = roles.map(role => {
        const appName = role.app ? role.app.Name : null;
        let displayName = role.app ? role.app.Name : null;
        if (role.app && role.app.environment) {
          displayName += ` (${role.app.environment})`;
        }
        const userEmail = role.user ? role.user.email : null;
        return {
          id: role.id,
          app: role.app,
          appId: role.appId,
          appName: appName,
          displayName: displayName,
          user: role.user,
          userId: role.userId,
          userEmail: userEmail,
          role: role.role
        };
      });
    },
    getRoles() {
      this.$store.dispatch('getRoles')
        .then(() => {
          this.parseRoles(this.$store.state.roles);
        })
        .catch(err => {});
    },
    openDialog(row) {
      if (row) {
        const userEmail = row.userEmail;
        this.isNew = false;
        this.selectedUser = this.usersCopy.find(user => user.email === userEmail);
        this.selectedApp = this.appsCopy.find(app => app.Name === row.appName);
        this.role = row;
      } else {
        this.isNew = true;
        this.role = {
          userId: null,
          appId: null,
          role: null
        };
      }
      this.$refs.dialog.open();
    },
    closeDialog(isSaved) {
      if (isSaved) {
        const actionName = this.isNew ? 'createRole' : 'updateRole';
        const roleForRequest = {
          appId: this.role.appId,
          userId: this.role.userId,
          role: this.role.role
        };
        if (this.role.id) {
          roleForRequest.id = this.role.id;
        }
        this.$store.dispatch(actionName, roleForRequest)
          .then(() => {
            this.getRoles();
          })
          .catch(err => {});
      }
      this.$refs.dialog.close();
      this.role = null;
      this.selectedUser = null;
      this.selectedApp = null;
    },
    openConfirmDialog(row) {
      this.role = row;
      this.$refs.confirmDialog.open();
    },
    closeConfirmDialog(isConfirmed) {
      if (isConfirmed) {
        this.$store.dispatch('deleteRole', this.role)
          .then(() => {
            this.getRoles();
          })
          .catch(err => {});
      }
      this.$refs.confirmDialog.close();
    },
  },
  mounted() {
    this.getRoles();
    this.usersCopy = _.sortBy(this.users, user => user.email.toLowerCase());
    this.appsCopy = _.sortBy(this.apps, app => app.Name.toLowerCase()).filter(a => !a.algorithmId).map(item => {
      if (item.environment) {
        item.displayName = `${item.Name} (${item.environment})`;
      } else {
        item.displayName = `${item.Name}`;
      }
      return item;
    });
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

<style>
  .md-dialog .md-input-container .multiselect__tags input, .md-dialog .md-input-container .multiselect__tags textarea {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// AdminRoles.vue?3f75c2bf